export const MAX_CONTENT_WIDTH = 1800; // px — widest the content is ever allowed to get
export const CONTENT_PADDING = 40; // px — gutter between content and the viewport edge

const screens = {
  sm: '576px',
  md: '768px',
  lg: '992px',
  xl: '1200px',
  '2xl': '1440px',
  '3xl': '1750px',
  // the viewport width at which content stops growing and starts being centered
  constrained: `${MAX_CONTENT_WIDTH + 2 * CONTENT_PADDING}px`,
  '4xl': '2040px',
  '5xl': '2360px',
};

export default screens;
